import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { getGameRecord } from '@sportninja/common/services/game/attendanceServices'

interface GameRecord {
  generic_sport_id?: string | number | null
  sport_id?: string | number | null
}

/**
 * Minimal game-record read for generic-sport / soccer flags used by the
 * starting-goalie/keeper column.
 *
 * `getGameRecord` already unwraps the `{ data }` envelope internally (see
 * common/services/game/attendanceServices.js), so `query.data` here is the
 * game record directly — not `{ data: ... }`.
 */
export const useAttendanceGameMeta = (
  gameId?: string,
  soccerSportId?: number
) => {
  const query = useQuery({
    queryKey: queryKeys.gameRaw.byId(gameId),
    queryFn: () => getGameRecord(gameId as string) as Promise<GameRecord>,
    enabled: Boolean(gameId),
  })

  const game = query.data
  return {
    isGenericSport: game?.generic_sport_id != null,
    isSoccer: !!soccerSportId && game?.sport_id === soccerSportId,
  }
}
